import React from "react";
import CustomButton from "../commons/CustomButton/CustomButton";

const ModalCookies = ({ gaConsent, handleAccept, handleDeny, isOpen }) => {
  // Si el usuario ya ha tomado una decisión, no mostrar el popup
  if (!isOpen || gaConsent !== null) return null;

  return (
    <>
      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(25px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <div
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: "24px",
          display: "flex",
          justifyContent: "center",
          pointerEvents: "none",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            pointerEvents: "auto",
            width: "620px",
            maxWidth: "95%",
            background: "#fff",
            borderRadius: "20px",
            padding: "24px 28px",
            border: "1px solid #ececec",
            boxShadow: "0 10px 35px rgba(0,0,0,.12)",
            animation: "slideUp .35s ease",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "18px",
            }}
          >
            <div
              style={{
                fontSize: "36px",
                flexShrink: 0,
              }}
            >
              🍪
            </div>

            <div style={{ flex: 1 }}>
              <h2
                style={{
                  margin: 0,
                  fontSize: "22px",
                  color: "#222",
                  fontWeight: 700,
                }}
              >
                Help us improve Spanish with Alex
              </h2>

              <p
                style={{
                  marginTop: "10px",
                  marginBottom: "20px",
                  color: "#666",
                  lineHeight: 1.6,
                  fontSize: "15px",
                }}
              >
                Optional analytics cookies help us understand how visitors use
                our website so we can improve our Spanish lessons and create a
                better learning experience.
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                <CustomButton
                  label="Only necessary cookies"
                  onClick={handleDeny}
                  colorScheme="blue"
                  variant="solid"
                />

                <CustomButton
                  label="Allow analytics"
                  onClick={handleAccept}
                  colorScheme="blue"
                  variant="solid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalCookies;
